import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ThinCheckbox } from 'components/common/Styles';
import FlexBox from 'components/common/FlexBox';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const QuestionnaireItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/questionnaires/${data.questionnaireId}`);
  }, [data, historyContext]);

  return (
    <TableRow hover key={data.questionnaireId}>
      <TableCell>{data.name}</TableCell>
      <TableCell>{data.code}</TableCell>
      <TableCell align='center'>{data.version}</TableCell>
      <TableCell>{data.validFrom ? t('DATE_FORMAT', { date: { value: data.validFrom, format: 'MM/DD/YYYY' } }) : ''}</TableCell>
      <TableCell>{data.validFrom ? t('DATE_FORMAT', { date: { value: data.validTo, format: 'MM/DD/YYYY' } }) : ''}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox disabled={true} size='small' checked={Boolean(data.active)} />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' color='primary' size='small' variant='text' tooltip={'Edit'} onClick={handleEdit} />
          <IconButton
            type='delete'
            color='primary'
            size='small'
            variant='text'
            tooltip={'Delete'}
            onClick={() => onDelete(data.questionnaireId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

QuestionnaireItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default QuestionnaireItem;
